export default __webpack_public_path__ + "static/media/pngegg.fef1950d.png";